export const lang = {
    'wirtualna-mata-do-kodowania': {'pl':'Wirtualna mata do kodowania', 'en': 'Virtual mata to code'},
    'mata-z-kratownica-10x10': {'pl':'Mata z kratownicą 10x10', 'en': 'mata 10x10 po ang :)'},
    'mata-z-kolorowymi-kolkami-9x9': {'pl':'Mata z kolorowymi kółkami 9x9', 'en': 'mata 9x9 po ang :)'},
    'kolorowe-kubeczki': {'pl':'Kolorowe kubeczki', 'en': 'Cups'},
    'cyfry': {'pl':'Cyfry', 'en': 'Numbers'},
    'symbole-ruchu': {'pl':'Symbole ruchu', 'en': 'Movements'},
    'arrow-up': {'pl':'DO PRZODU', 'en': 'MOVE FORWARD'},
    'arrow-down': {'pl':'DO TYŁU', 'en': 'MOVE BACKWARD'},
    'arrow-left': {'pl':'W LEWO', 'en': 'LEFT'},
    'arrow-right': {'pl':'W PRAWO', 'en': 'RIGHT'},
    'play': {'pl': 'START', 'en': 'START'},
    'stop': {'pl': 'STOP', 'en': 'STOP'},
    'link-do-twojej-maty': {'pl':'Link do Twojej maty:', 'en': 'URL to your mata'},
    'kopiuj': {'pl': 'Kopiuj do schowka', 'en': 'Copy to clipboard'},
    'skopiowane': {'pl': 'Skopiowano!', 'en': 'Copied!'},
    'udostepnij': {'pl': 'Udostępnij', 'en': 'Share'},
    'pobierz-na-dysk-jako': {'pl': 'Pobierz na dysk jako:', 'en': 'Save as:'},
    'obrazek': {'pl': 'OBRAZEK', 'en': 'PICTURE'},
    'wszelkie-prawa-zastrzezone': {'pl': 'WSZELKIE PRAWA ZASTRZEŻONE', 'en': 'ALL RIGHTS RESERVED'}
};

export const colors = ['#e20613', '#63c2d0', '#ee7d00', '#aec90b', '#f4b4d2', '#94a5b0', '#ffcb00', '#6f3f80', '#008ad1', '#ffffff'];




// WEBPACK FOOTER //
// ./src/dictionary.js